export const KRATOS_PAYMENTS_ROUTE = '/kratos/payments';
export const KRATOS_ADD_NEW_PAYMENT_ROUTE = '/kratos/payments/new';
export const KRATOS_ADDRESSES_ROUTE = '/kratos/addresses';
export const KRATOS_ADD_NEW_ADDRESS_ROUTE = '/kratos/addresses/new';

export const PAYMENTS_ROUTE = '/payments';
export const ADD_NEW_PAYMENT_ROUTE = '/payments/new';
export const ADDRESSES_ROUTE = '/addresses';
export const ADD_NEW_ADDRESS_ROUTE = '/addresses/new';
export const BIRTHDAY_ROUTE = '/account/birthday';
export const REWARDS_DASHBOARD_ROUTE = '/account/rewards';

export const PRIVACY_DATA_SHARING_ROUTE = '/account/privacy-data-sharing';
export const PRIVACY_POLICY_ROUTE = '/c/privacy-policy';
export const INTEREST_BASED_ADS_ROUTE = '/c/interest-based-ads-policy';

export const KIDS_SHOE_SIZE_CHART_ROUTE = '/c/kids-shoe-size-chart';
